module.exports = __webpack_public_path__ + "static/_03-d57f17ae0ed2aa15756c66977ba94921.jpg";